import { CopyText } from '../i18n/Language';
import { useLanguage } from '../i18n/Language';
import ArrowIcon from './ArrowIcon';
import { projects } from '../data/studio';

export default function ProjectList() {
  const { t } = useLanguage();
  return (
    <div className="project-list">
      {projects.map(project => (
        <article className={`project project-${project.name.toLowerCase()}`} key={project.name}>
          <div className="project-header">
            <a className="project-image" href={project.url} target="_blank" rel="noreferrer" aria-label={project.name}>
              <img src={project.image} alt={t(project.alt)} loading="lazy" width="68" height="68" />
            </a>
            <div className="project-title-group">
              <h3><a href={project.url} target="_blank" rel="noreferrer">{project.name}</a></h3>
              <span className="project-meta"><CopyText source={project.type} /></span>
            </div>
          </div>
          <div className="project-copy">
            <p><CopyText source={project.description} /></p>
          </div>
          <div className="project-card-footer">
            <a className="project-visit" href={project.url} target="_blank" rel="noreferrer" aria-label={`${t(project.cta || 'Visit website')} ${project.name}`}>
              <span><CopyText source={project.cta || 'Visit website'} /></span>
              <ArrowIcon className="visit-arrow" />
            </a>
          </div>
        </article>
      ))}
    </div>
  );
}
